module.exports = __webpack_public_path__ + "static/img/a.b85e860.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-go/mobile/photo_pack/a.png
// module id = 57CB
// module chunks = 12